import React, { useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import './RegulatoryControl.css';

function RegulatoryControl() {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <div className="page-container">
      <Container>
        <div className="page-header">
          <h1>Regulatory Control Center</h1>
          <p className="lead">Comprehensive regulatory compliance monitoring and management</p>
        </div>
        
        <Row className="content-section">
          <Col lg={4} md={6} className="mb-4">
            <Card className="feature-card h-100">
              <Card.Body className="text-center">
                <i className="bi bi-clipboard-check feature-icon"></i>
                <Card.Title className="mt-3">Compliance Monitoring</Card.Title>
                <Card.Text>Track and assess regulatory compliance status in real-time</Card.Text>
                <Button variant="outline-primary" className="mt-3" onClick={() => setShowDetails(!showDetails)}>
                  View Details
                </Button>
              </Card.Body>
            </Card>
          </Col>
          
          <Col lg={4} md={6} className="mb-4">
            <Card className="feature-card h-100">
              <Card.Body className="text-center">
                <i className="bi bi-shield-lock feature-icon"></i>
                <Card.Title className="mt-3">Policy Management</Card.Title>
                <Card.Text>Centralized platform for regulatory policies and control frameworks</Card.Text>
                <Button variant="outline-primary" className="mt-3">Access Policies</Button>
              </Card.Body>
            </Card>
          </Col>
          
          <Col lg={4} md={6} className="mb-4">
            <Card className="feature-card h-100">
              <Card.Body className="text-center">
                <i className="bi bi-journal-check feature-icon"></i>
                <Card.Title className="mt-3">Audit Controls</Card.Title>
                <Card.Text>Comprehensive tools for regulatory audit management and reporting</Card.Text>
                <Button variant="outline-primary" className="mt-3">View Audits</Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col md={6}>
            <Card>
              <Card.Body>
                <h4>Compliance Status</h4>
                <div className="compliance-grid">
                  <div className="compliance-item">
                    <div className="compliance-header">
                      <h5>Data Protection</h5>
                      <span className="badge bg-success">Compliant</span>
                    </div>
                    <div className="progress">
                      <div className="progress-bar bg-success" style={{width: '95%'}}></div>
                    </div>
                    <p>Last verified: 2 days ago</p>
                  </div>
                  <div className="compliance-item">
                    <div className="compliance-header">
                      <h5>Privacy Controls</h5>
                      <span className="badge bg-warning">Review Required</span>
                    </div>
                    <div className="progress">
                      <div className="progress-bar bg-warning" style={{width: '85%'}}></div>
                    </div>
                    <p>Review due in 5 days</p>
                  </div>
                  <div className="compliance-item">
                    <div className="compliance-header">
                      <h5>Security Standards</h5>
                      <span className="badge bg-success">Compliant</span>
                    </div>
                    <div className="progress">
                      <div className="progress-bar bg-success" style={{width: '92%'}}></div>
                    </div>
                    <p>Last verified: 1 day ago</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          
          <Col md={6}>
            <Card>
              <Card.Body>
                <h4>Recent Regulatory Updates</h4>
                <div className="updates-timeline">
                  <div className="timeline-item">
                    <div className="timeline-icon">
                      <i className="bi bi-file-text"></i>
                    </div>
                    <div className="timeline-content">
                      <h5>Policy Update: Data Retention</h5>
                      <p>New requirements for data retention periods</p>
                      <small>2 days ago</small>
                    </div>
                  </div>
                  <div className="timeline-item">
                    <div className="timeline-icon">
                      <i className="bi bi-shield-check"></i>
                    </div>
                    <div className="timeline-content">
                      <h5>Security Protocol Update</h5>
                      <p>Enhanced encryption standards implemented</p>
                      <small>5 days ago</small>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {showDetails && (
          <Row className="mt-4">
            <Col md={12}>
              <Card>
                <Card.Body>
                  <h4>Detailed Compliance Analytics</h4>
                  <Row>
                    <Col md={6}>
                      <div className="stats-item">
                        <h5>Total Controls</h5>
                        <p className="display-4">156</p>
                        <small className="text-success">+12 from last month</small>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="stats-item">
                        <h5>Compliance Rate</h5>
                        <p className="display-4">94%</p>
                        <small className="text-success">+2.5% from last month</small>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}

export default RegulatoryControl;
